import type { PropType } from 'virtual-vue';

const BaseKeyboardInputProps = {
  /**
   * 输入提示文案
   * @default ''
   */
  placeholder: {
    type: String,
    default: '',
  },
  /**
   * 输入提示语展示位置，可选值为 'left'（在光标左侧）或 'right'（在光标右侧）
   * @default 'right'
   */
  placeholderPosition: {
    type: String as PropType<'left' | 'right'>,
    default: 'right',
  },
  /**
   * 是否可输入小数点
   * @default true
   */
  decimal: {
    type: Boolean,
    default: true,
  },
  /**
   * 键盘类型，可选值为 'default'（默认键盘）、'confirm'（带确认按钮的键盘）
   * @default 'default'
   */
  type: {
    type: String as PropType<'default' | 'confirm'>,
    default: 'default',
  },
  /**
   * 键盘内的确认按钮文案
   * @default 'OK'
   */
  confirmBtnText: {
    type: String,
    default: 'OK',
  },
  /**
   * 是否允许用户点击键盘内嵌的确认按钮进行提交
   * @default false
   */
  confirmBtnEnable: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否一直显示键盘
   * @default false
   */
  alwaysShowKeyboard: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否禁用
   * @default false
   */
  disabled: {
    type: Boolean,
    default: false,
  },
};

/**
 * AmountInput组件的props
 */
export const AmountInputProps = {
  /**
   * 标题
   * @default ''
   */
  title: {
    type: String,
    default: '',
  },
  /**
   * 金额值（单位：分）
   * @default 0
   */
  value: {
    type: Number,
    default: 0,
  },
  /**
   * 币种描述
   * @default 'HK$'
   */
  currency: {
    type: String,
    default: 'HK$',
  },
  /**
   * 金额字符最大输入长度，包含小数部分（3位）
   * maxlength=9时，整数部分最多可输入9-3=6位
   * @default 9
   */
  maxlength: {
    type: Number,
    default: 9,
  },
  /**
   * 错误提示文案
   * @default ''
   */
  errorMsg: {
    type: String,
    default: '',
  },

  ...BaseKeyboardInputProps,
};


